import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a390fd4f7111800149179a1_1782559237013_0ac5a2c1/lunoraarena/src/app/settings/page.tsx");
